import { keys, isNil } from 'lodash';
import Xregexp from 'xregexp';

import { _addErrors } from './_addErrors';

function pattern(withAnchors: boolean) {
  return Xregexp(
    `${withAnchors ? '^' : ''}(?<relationName>\\w+)\\.(?<errorIndex>\\d+)\\.(?<locale>\\w{2,2})\\.(?<fieldName>\\w+)${
      withAnchors ? '$' : ''
    }`,
  );
}

/**
 * @description
 * Remap and add to errorsStore, BE errors errors, specifically:
 * relation.<index>.<locale>.fieldname to relation.<index>.fieldname
 *
 */
function catchErrorsForRelationWithLocale(errors: RawError | nil) {
  if (!errors) {
    return;
  }

  const errorKeys = keys(errors);

  const mappedErrors = errorKeys.reduce((processedErrors, errorKey) => {
    const match = Xregexp.exec(errorKey, pattern(true));

    if (!match) {
      return processedErrors;
    }

    let { fieldName, errorIndex, relationName } = match;
    const parsedErrorIndex = parseInt(match.errorInde);

    if (isNil(parsedErrorIndex)) {
      return processedErrors;
    }

    const newErrorKey = `${relationName}.${errorIndex}.${fieldName}`;

    const oldErrors = errors[errorKey] || [];
    const newErrors = oldErrors.map((error) => Xregexp.replace(error, pattern(false), '$<fieldName>'));

    processedErrors[newErrorKey] = newErrors;

    return processedErrors;
  }, {});
  return mappedErrors;
}

export { catchErrorsForRelationWithLocale };
